import { ListChecks } from 'lucide-react';
import { EmptyState } from '../components/EmptyState';

export function YardTasksPage() {
  return (
    <>
      <h1 className="mb-4 text-xl font-semibold tracking-tight text-fg">Today&apos;s tasks</h1>
      <EmptyState icon={ListChecks} title="Nothing to do yet" description="Gate checks, defect captures and on-behalf entries for drivers will appear here." />
    </>
  );
}
